import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  zoom: 6,
  lng: 0,
  lat: 0,
  partner: "",
  "partner-latitude": 0,
  "partner-longitude": 0,
  country: "United Kingdom",
  countryName:'United Kingdom',
  partnerId: "",
  tabValue: "",
  micrositeName: "",
  Page: "",
  sharedSite: "",
  usePartnerName: "",
  partnerName: "",
  accessToken: "",
  profID: "",
  county: "",
  state: "",
  ageID: "",
  designation: "",
  aboutUsKey: "",
  micrositeID: "",
  micrositeLogo: "",
  age: "",
  ageName: "",
  'contact-tabValue': "",
  sector: "",
  subSector: "",
  searchName: "",
  size: "",
  'Interest/AssetType': "",
  refresh: "",
  OrganisationType: "",
  organisationNameById: '',
  tabConfigId: "",
  carouselId: "",
  userDetails: {},
  subSectorResponse:[]
}

const localStorageSlice = createSlice({
  name: "localStorage",
  initialState,
  reducers: {
    updateZoom: (state, action) => {
      state.zoom = action.payload;
    },
      setSubSectorResponse: (state, action) => {
      state.subSectorResponse = action.payload;
    },
    setLang: (state, action) => {
      state.lng = action.payload;
    },
    setLat: (state, action) => {
      state.lat = action.payload;
    },
     setUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },
    setPartner: (state, action) => {
      state.partner = action.payload;
    },
    setPartnerLongitude: (state, action) => {
      state["partner-longitude"] = action.payload;
    },
    setPartnerLatitude: (state, action) => {
      state["partner-latitude"] = action.payload;

    },
    setCountry: (state, action) => {
      state.countryName = action.payload;
    },
    setPartnerId: (state, action) => {
      state.partnerId = action.payload;
    },

    setTabValue: (state, action) => {
      state.tabValue = action.payload;
    },

    setMicroSiteName: (state, action) => {
      state.micrositeName = action.payload;
    },
    setPage: (state, action) => {
      state.Page = action.payload;
    },
    setSharedSite: (state, action) => {
      state.sharedSite = action.payload;
    },
    setUsePartnerName: (state, action) => {
      state.usePartnerName = action.payload;
    },
    setPartnerName: (state, action) => {
      state.partnerName = action.payload;
    },
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
    setProfID: (state, action) => {
      state.profID = action.payload;
    },
    updateCountry: (state, action) => {
      state.country = action.payload;
    },
    updateCounty: (state, action) => {
      state.county = action.payload;
    },
    setState: (state, action) => {
      state.state = action.payload
    },
    setAgeId: (state, action) => {
      state.ageID = action.payload
    },
    setDesignation: (state, action) => {
      state.designation = action.payload
    },
    updateAboutUsKey: (state, action) => {
      state.aboutUsKey = action.payload
    },
    updateMicrositeID: (state, action) => {
      state.micrositeID = action.payload
    },
    updateAge: (state, action) => {
      state.age = action.payload
    },
    updateAgeName: (state, action) => {
      state.ageName = action.payload
    },
    setMicroSiteLogo: (state, action) => {
      state.micrositeLogo = action.payload
    },
    setContactTabValue: (state, action) => {
      state["contact-tabValue"] = action.payload
    },
    setSearchName: (state, action) => {
      state.searchName = action.payload
    },
    setSize: (state, action) => {
      state.size = action.payload
    },
    setInterestAndAssetType: (state, action) => {
      state["Interest/AssetType"] = action.payload
    },
    setSector: (state, action) => {
      state.sector = action.payload
    },
    setSubSector: (state, action) => {
      state.subSector = action.payload
    },
    setRefresh: (state, action) => {
      state.refresh = action.payload
    },
    setOrganisationType: (state, action) => {
      state.OrganisationType = action.payload
    },
    updateOrganisationNameById: (state, action) => {
      state.organisationNameById = action.payload
    },
    setTabConfigId: (state, action) => {
      state.tabConfigId = action.payload
    },
    setCarouselId: (state, action) => {
      state.carouselId = action.payload
    },
    resetLocalStorage: () => initialState
  },
});

export const {
  updateZoom,
  setLang,
  setLat,
  setPartner,
  setPartnerId,
  setTabValue,
  setMicroSiteName,
  setPage,
  setSharedSite,
  setUsePartnerName,
  setPartnerLatitude,
  setPartnerLongitude,
  setPartnerName,
  setAccessToken,
  setProfID,
  updateCountry,
  updateCounty,
  setState,
  setAgeId,
  setDesignation,
  updateAboutUsKey,
  updateMicrositeID,
  updateAge,
  updateAgeName,
  setMicroSiteLogo,
  setContactTabValue,
  setSector,
  setSubSector,
  setSearchName,
  setSize,
  setInterestAndAssetType,
  setRefresh,
  setOrganisationType,
  setTabConfigId,
  setCarouselId,
  resetLocalStorage,
  updateOrganisationNameById,
  setUserDetails,
  setCountry,
  setSubSectorResponse
} = localStorageSlice.actions;
export default localStorageSlice.reducer;
